<template>
    <sponsors-editor v-model="sponsors"
                     :sponsors-footer-logo="project.sponsorsFooterLogo"
                     :disabled="project.isArchived"
                     @sponsorsFooterLogoChange="changeFooterLogo"
    />
</template>

<script>
    import SponsorsEditor from '@/components/controls/sponsors/SponsorsEditor';
    import { getValidSponsors } from '@/services/SponsorService';
    import { mapActions, mapMutations, mapState } from 'vuex';

    export default {
        name: 'GeneralSettings',
        components: {
            SponsorsEditor,
        },
        computed:{
            ...mapState('projects', ['project']),
            sponsors: {
                get() {
                    return this.project.sponsors;
                },
                async set(value) {
                    this.setSponsors(value);
                    await this.saveProject({
                        key: 'sponsors',
                        value: getValidSponsors(value),
                    });
                },
            },
            currentEvent(){
                return this.project?.events[0]?._id;
            },
        },
        methods:{
            ...mapMutations('projects', ['setSponsors', 'setSponsorsFooterLogo']),
            ...mapActions('projects', [ 'saveProject']),
            async changeFooterLogo(value) {
                this.setSponsorsFooterLogo(value);
                await this.saveProject({
                    key: 'sponsorsFooterLogo',
                    value: value,
                });
            }
        }
    };
</script>
